// import React, { Component } from "react";
// import './ControlPanel.css'
// import Chips from "../../../../../library/Chips/Chips";
// import DynamicCircle from "./Chips";

// const data = [
//   { color: "red", chip: 1 },
//   { color: "green", chip: 10 },
//   { color: "blue", chip: 20 },
//   { color: "purple", chip: 50 },
//   { color: "yellow", chip: 100 },
//   { color: "teal", chip: 500 },
//   { color: "brown", chip: 1000 },
//   { color: "black", chip: 5000 }
// ];
// export class ControlPanel extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       index: 0,
//     };

//   }
//   handleLeft = () => {
//     this.setState((prevState) => ({
//       index:
//         prevState.index === 0 ? data.length - 1 : prevState.index - 1,
//     }));
//   };

//   handleRight = () => {
//     this.setState((prevState) => ({
//       index:
//         prevState.index === data.length - 1 ? 0 : prevState.index + 1,
//     }));
//   };

//   selectedBet = () => {

//     this.props.BetAmountHandle(this.props.BetAmount + Number(data[this.state.index].chip))
//   }
//   render() {
//     const { selected, onDraw, onClear, onAutoPick, isPotrait, BetAmountHandle, HalfAmounthandler, DoubleAmounthandler, BetAmount, Gridcover, balance, winpop } = this.props;
//     const { index } = this.state;
//     const current = data[index];


//     return (
//       <div className={`control-panel  fd`}>

//         <div className={`${isPotrait ? 'col-12' : 'col-8'} row flex_row`}>
//           {/* <div className="col-2 box-shadow betbg m_t_5">
//             <input className="fd p_25 box-shadow font_25 no-spinner border_none" type="number" key={"increment"} min={1} value={BetAmount} max={balance} onChange={BetAmountHandle} />
//             <button className="col-2 font_25" onClick={HalfAmounthandler}>1/2</button>
//               <button className="col-2 font_25" onClick={DoubleAmounthandler}>2</button>
//           </div> */}



//           <button onClick={onClear} className="col-2  p_15 font_25  btn2 box-shadow" disabled={Gridcover || winpop}>
//             Clear Table
//           </button>
//           <div className={`${isPotrait ? 'col-3' : 'col-3'} chippanel`}>

//             <button className="leftBtn" onClick={this.handleLeft} disabled={index === 0}>◄</button>
//             <DynamicCircle value={current.chip} color={current.color} selectedBet={this.selectedBet} disabled={Gridcover || winpop} />
//             <button id="rightBtn" onClick={this.handleRight} disabled={index === data.length - 1} >►</button>


//           </div>
//           <div className="col-2 BetAmount btn1">
//             {!isPotrait && <button onClick={() => { this.props.BetAmountHandle(0) }} disabled={Gridcover || winpop}>X</button>}
//             <div>
//               <span>Bet Amount</span>
//               <span>{BetAmount}</span>
//             </div>
//           </div>
//           <button onClick={onAutoPick} className="col-2  p_15 font_25  btn1 box-shadow" disabled={Gridcover || winpop}>
//             Auto Pick
//           </button>


//           <button onClick={onDraw} className="col-2 p_15 font_25  btn3 box-shadow" disabled={selected.length === 0 || Gridcover || winpop || (Number(BetAmount) === 0 && (Number(balance) - Number(BetAmount)) != 0)}>
//             Bet
//           </button>
//         </div>







//       </div>
//     );
//   }
// }

// export default ControlPanel;
import React, { Component } from "react";
import './ControlPanel.css';
import Chips from "../../../../../library/Chips/Chips";
import DynamicCircle from "./Chips";
import { Howl, Howler } from "howler";
import changefile from '../../../../../assets/Kenostakewav/changerightleft.mp3'
import chipfile from '../../../../../assets/Kenostakewav/chip.wav'
const changesound = new Howl({
  src: [changefile]  // Make sure the path is correct
});
const chipsound = new Howl({
  src: [chipfile]  // Make sure the path is correct
});
export class ControlPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      index: 0,
    };
  }

  handleLeft = () => {
    if (changesound) {
      Howler.stop();
      changesound.play();
    }
    const { data, BetAmountHandle,balance } = this.props;
    this.setState((prevState) => {
      const newIndex = prevState.index === 0 ? data.length - 1 : prevState.index - 1;
      return { index: newIndex };
    }, () => {
      // After state is updated, update BetAmount
      BetAmountHandle(Number(data[this.state.index].chip));
      if(Number(data[this.state.index].chip)>balance){
        this.props.showAlert(`Insufficient funds`) 
      }
    });
  };

  handleRight = () => {
    if (changesound) {
      Howler.stop();
      changesound.play();
    }
    const { data, BetAmountHandle,balance } = this.props;
    this.setState((prevState) => {
      const newIndex = prevState.index === data.length - 1 ? 0 : prevState.index + 1;
      return { index: newIndex };
    }, () => {
      // After state is updated, update BetAmount
      
      BetAmountHandle(Number(data[this.state.index].chip));
      if(Number(data[this.state.index].chip)>balance){
        this.props.showAlert(`Insufficient funds`)
      }
    });
  };

  // handleLeft = () => {
  //   if (changesound) {
  //     Howler.stop();
  //     changesound.play();
  //   }
  //   const { data } = this.props;
  //   this.setState((prevState) => ({
  //     index: prevState.index === 0 ? data.length - 1 : prevState.index - 1,
  //   }));
  // };

  // handleRight = () => {
  //   if (changesound) {
  //     Howler.stop();
  //     changesound.play();
  //   }
  //   const { data } = this.props;
  //   this.setState((prevState) => ({
  //     index: prevState.index === data.length - 1 ? 0 : prevState.index + 1,
  //   }));
  // };

  selectedBet = () => {
    const { data, BetAmount, BetAmountHandle, Keno_stake_minBet, Keno_stake_maxBet } = this.props;
    const { index } = this.state;
    const selectedChip = Number(data[index].chip);
    const newBetAmount = BetAmount + selectedChip;

    if (newBetAmount >= Keno_stake_minBet && newBetAmount <= Keno_stake_maxBet) {
      if (chipsound) {
        // Howler.stop();
        chipsound.play();
      }
      BetAmountHandle(newBetAmount);
    } else {
      console.warn("Bet amount must be between 1 and 1000.");

      this.props.showAlert(`Bet amount must be between ${Keno_stake_minBet} and ${Keno_stake_maxBet}.`)
      // Optional: Add a UI feedback here
    }
  };

  render() {
    const {
      selected,
      onDraw,
      onClear,
      onAutoPick,
      isPotrait,
      BetAmountHandle,
      HalfAmounthandler,
      DoubleAmounthandler,
      BetAmount,
      Gridcover,
      balance,
      winpop,
      data,
    } = this.props;

    const { index } = this.state;

    if (!data || data.length === 0) {
      return <div className="control-panel">No chip data available.</div>;
    }

    // const current =BetAmount===1?data[0]: data[index];
    const current = BetAmount === 1 ? data[0] : data[index];

    return (
      <div className={`control-panel fd`}>
        <div className={`${isPotrait ? 'col-12' : 'colmini'} row flex_row`}>
          <div className={`${isPotrait ? 'col-12' : 'col-6'} row flex_row`}>

            <button
              // onClick={onClear}
              onClick={() => {
                onClear(); // Call the parent function
                this.setState({ index: 0 }); // Reset local state
              }}
              className={`${isPotrait ? 'col-4' : 'col-3'} p_15 font_25 btn2 box-shadow`}
              // disabled={Gridcover || winpop || selected.length == 0||Number(BetAmount)===1}
              disabled={Gridcover || winpop || (selected.length === 0 && Number(BetAmount) === 1)}
            >
              Clear
            </button>

            <div className={`${isPotrait ? 'col-6' : 'col-8'} chippanel`}>
              <button
                className="leftBtn"
                onClick={this.handleLeft}
                disabled={index === 0}
              >
                ◄
              </button>
              <DynamicCircle
                value={current.chip}
                color={current.color}
                selectedBet={this.selectedBet}
                disabled={Gridcover || winpop}
                isPotrait={isPotrait}
              />
              <button
                id="rightBtn"
                onClick={this.handleRight}
                disabled={index === data.length - 1}
              >
                ►
              </button>
            </div>
          </div>
          <div className={`${isPotrait ? 'col-12' : 'col-6 '} row flex_row`}>
            <div className={`${isPotrait ? 'col-3' : 'col-3'} BetAmount btn1 m_r_5_per`}>
              {false && (
                // {!isPotrait && (
                <button
                  onClick={() => BetAmountHandle(1)}
                  disabled={Gridcover || winpop}
                >
                  X
                </button>
              )}
              <div>
                <span>Bet Amount</span>
                <span>{BetAmount}</span>
              </div>
            </div>

            <button
              onClick={onAutoPick}
              className={`${isPotrait ? 'col-3' : 'col-3'} p_15 font_25 btn1 box-shadow m_l_10_per`}
              disabled={Gridcover || winpop}
            >
              Auto Pick
            </button>

            <button
              onClick={onDraw}
              className={`${isPotrait ? 'col-3' : 'col-3'} p_15 font_25 btn3 box-shadow m_l_10_per`}
              disabled={
                selected.length === 0 ||
                Gridcover ||
                winpop ||
                (Number(BetAmount) === 0 &&
                  Number(balance) - Number(BetAmount) !== 0)
              }
            >
              Bet
            </button>

          </div>
        </div>
      </div>
    );
  }
}

export default ControlPanel;
